import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import { CaptainVirtualEntryChangeModal } from './CaptainVirtualEntryChangeModal.jsx';
import {
  handleVirtualEntryChangeCaptainCancelClick,
  handleVirtualEntryChangeCaptainSearchClick,
  handleChangeVirtualEntriesCaptainFormSave,
  validateVirtualEntryCaptainChangeForm
} from './actions';

const mapStateToProps = state => {
  return ({ 
    visible: state.admin.virtualEventDetail.showCaptainVirtualEntryChangeModal,  
    isNew: state.admin.virtualEventDetail.isNewCaptainOnSearch,  
    submitButtonText: state.admin.virtualEventDetail.isNewCaptainOnSearch ? 'Create' : 'Update',  
    validate: validateVirtualEntryCaptainChangeForm,
    hasError: state.shared.error.source && state.shared.error.source.length > 0
  });
};

const mapDispatchToProps = dispatch => ({
  onCancelClick: () => dispatch(handleVirtualEntryChangeCaptainCancelClick()),
  onSubmit: data => dispatch(handleChangeVirtualEntriesCaptainFormSave(data)),
  onSearchClick: () => dispatch(handleVirtualEntryChangeCaptainSearchClick())
});

const entryCaptainChangeReduxForm =  reduxForm({
  form: 'CaptainVirtualEntryChangeForm'
})(CaptainVirtualEntryChangeModal);

export default connect(mapStateToProps, mapDispatchToProps)(entryCaptainChangeReduxForm);



// WEBPACK FOOTER //
// ./src/features/admin/virtualEventDetail/CaptainVirtualEntryChangeModalContainer.jsx